export default __webpack_public_path__ + "static/AppMoneyWalkie5-80ff538b4034a638b7ee17e8019578ba.png";